import Calender from "../../components/ClassOne/Mathematics/Calender";
import DataHandling from "../../components/ClassOne/Mathematics/DataHandling";
import Fraction from "../../components/ClassOne/Mathematics/Fraction";
import DataHandlingmenu from "./DataHandling";
import Fractionmenu from "./Fraction";
import Calendermenu from "./Calender";
import Measurement from "../../components/ClassOne/Mathematics/Measurement";
import Measurementmenu from "./Measurement";
import Clock from "../../components/ClassOne/Mathematics/Clock";
import Clockmenu from "./Clock";
import Patterns from "../../components/ClassOne/Mathematics/Patterns";
import Patternsmenu from "./Patterns";
import Shapes from "../../components/ClassOne/Mathematics/Shapes";
import Shapesmenu from "./Shapes";
import NumberMath from "../../components/ClassOne/Mathematics/NumberMath";
import NumberMathmenu from "./NumberMath";
import Addition from "../../components/ClassOne/Mathematics/Addition";
import Additionmenu from "./Addition";
import Subtraction from "../../components/ClassOne/Mathematics/Subtraction";
import Subtractionmenu from "./Subtraction";
import GreaterLessThan from "../../components/ClassOne/Mathematics/GreaterLessThan";
import GreaterLessThanmenu from "./GreaterLessThan";
import Money from "../../components/ClassOne/Mathematics/Money";
import Moneymenu from "./Money";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/class-one/mathematics/number-math", title: "Number Math", component: NumberMath, subMenu: NumberMathmenu },
    // { url: "/class-one/mathematics/spatial-understanding", title: "Spatial Understanding" },
    { url: "/class-one/mathematics/addition", title: "Addition", component: Addition, subMenu: Additionmenu },
    { url: "/class-one/mathematics/substraction", title: "Subtraction", component: Subtraction, subMenu: Subtractionmenu },
    { url: "/class-one/mathematics/greater-less-than", title: "> or < or =", component: GreaterLessThan, subMenu: GreaterLessThanmenu },
    { url: "/class-one/mathematics/patterns", title: "Patterns", component: Patterns, subMenu: Patternsmenu },
    { url: "/class-one/mathematics/money", title: "Money", component: Money, subMenu: Moneymenu },
    //{ url: "/class-one/mathematics/shapes", title: "Shapes", component: Shapes, subMenu: Shapesmenu },
    { url: "/class-one/mathematics/clock", title: "Clock", component: Clock, subMenu: Clockmenu },
    { url: "/class-one/mathematics/calender", title: "Calender", component: Calender, subMenu: Calendermenu },
    { url: "/class-one/mathematics/fraction", title: "Fraction", component: Fraction, subMenu: Fractionmenu },
    { url: "/class-one/mathematics/measurement", title: "Measurement", component: Measurement,  subMenu: Measurementmenu},
    { url: "/class-one/mathematics/data-handling", title: "Data Handling", component: DataHandling,  subMenu: DataHandlingmenu},
];


export default topics;